const API_URL = 'https://bot.devit.es/api';

const getToken = () => localStorage.getItem('devit_token');

const headers = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${getToken()}`
});

export const auth = {
  login: (email, password) =>
    fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    }).then(r => r.json()),

  register: (nombre, email, password) =>
    fetch(`${API_URL}/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ nombre, email, password })
    }).then(r => r.json()),

  // ── Reset de contraseña ──────────────────────────────────────────────────
  resetPasswordRequest: (email) =>
    fetch(`${API_URL}/auth/reset-password-request`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    }).then(r => r.json()),

  resetPasswordConfirm: (token, nueva_password) =>
    fetch(`${API_URL}/auth/reset-password-confirm`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, nueva_password }),
    }).then(r => r.json()),
};

export const tenant = {
  getMe: () =>
    fetch(`${API_URL}/tenants/me`, { headers: headers() }).then(r => r.json()),

  update: (data) =>
    fetch(`${API_URL}/tenants/me`, {
      method: 'PUT',
      headers: headers(),
      body: JSON.stringify(data)
    }).then(r => r.json()),

  // Onboarding wizard — guarda config inicial y activa el agente
  setup: (data) =>
    fetch(`${API_URL}/tenants/setup`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify(data)
    }).then(r => r.json()),

  // ✅ AÑADIDO: desglose de tokens por canal
  getTokensHistorico: () =>
    fetch(`${API_URL}/admin/blog/tokens/historico`, { headers: headers() }).then(r => r.json()),

  getTokensDetalle: () =>
    fetch(`${API_URL}/admin/blog/tokens/detalle`, { headers: headers() }).then(r => r.json()),

  getTokenUsage: () =>
    fetch(`${API_URL}/tenants/tokens/usage`, { headers: headers() }).then(r => r.json()),

  getWebhookUrls: () =>
    fetch(`${API_URL}/tenants/webhook-urls`, { headers: headers() }).then(r => r.json()),

  getWhisperUsage: () =>
    fetch(`${API_URL}/tenants/whisper/usage`, { headers: headers() }).then(r => r.json()),

  toggleWhisper: () =>
    fetch(`${API_URL}/tenants/whisper/toggle`, {
      method: 'PUT', headers: headers()
    }).then(r => r.json()),
};

export const billing = {
  getPlanes: () =>
    fetch(`${API_URL}/billing/planes`).then(r => r.json()),

  checkout: (plan) =>
    fetch(`${API_URL}/billing/checkout`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify({ plan })
    }).then(r => r.json()),

  portal: () =>
    fetch(`${API_URL}/billing/portal`, {
      method: 'POST',
      headers: headers()
    }).then(r => r.json()),

  cambiarPlan: (plan) =>
    fetch(`${API_URL}/billing/cambiar-plan`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify({ plan })
    }).then(r => r.json()),
};

// ── Cualificación ─────────────────────────────────────────────────────────
export const cualificacion = {
  get: () =>
    fetch(`${API_URL}/cualificacion`, { headers: headers() }).then(r => r.json()),

  update: (data) =>
    fetch(`${API_URL}/cualificacion`, {
      method: 'PUT',
      headers: headers(),
      body: JSON.stringify(data)
    }).then(r => r.json()),
};

// ── Leads ─────────────────────────────────────────────────────────────────
export const leads = {
  getAll: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.tipo_lead) params.append('tipo_lead', filters.tipo_lead);
    if (filters.canal)     params.append('canal', filters.canal);
    if (filters.estado)    params.append('estado', filters.estado);
    const qs = params.toString();
    return fetch(`${API_URL}/leads/${qs ? '?' + qs : ''}`, { headers: headers() }).then(r => r.json());
  },

  update: (id, data) =>
    fetch(`${API_URL}/leads/${id}`, {
      method: 'PUT',
      headers: headers(),
      body: JSON.stringify(data)
    }).then(r => r.json()),

  getStats: () =>
    fetch(`${API_URL}/leads/stats`, { headers: headers() }).then(r => r.json()),
};

// ── Admin ──────────────────────────────────────────────────────────────────
export const admin = {
  getHealth: () =>
    fetch(`${API_URL}/admin/health`, { headers: headers() }).then(r => r.json()),
};
// ── Job Offers (Reclutador) ────────────────────────────────────────────────
export const jobOffers = {
  getAll: (soloActivas = true) =>
    fetch(`${API_URL}/job-offers/?solo_activas=${soloActivas}`, { headers: headers() }).then(r => r.json()),

  get: (id) =>
    fetch(`${API_URL}/job-offers/${id}`, { headers: headers() }).then(r => r.json()),

  create: (data) =>
    fetch(`${API_URL}/job-offers/`, {
      method: 'POST', headers: headers(), body: JSON.stringify(data)
    }).then(r => r.json()),

  update: (id, data) =>
    fetch(`${API_URL}/job-offers/${id}`, {
      method: 'PUT', headers: headers(), body: JSON.stringify(data)
    }).then(r => r.json()),

  deactivate: (id) =>
    fetch(`${API_URL}/job-offers/${id}`, {
      method: 'DELETE', headers: headers()
    }).then(r => r.json()),
};

// ── Candidates (Reclutador) ────────────────────────────────────────────────
export const candidates = {
  getAll: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.oferta_id) params.append('oferta_id', filters.oferta_id);
    if (filters.estado)    params.append('estado',    filters.estado);
    const qs = params.toString();
    return fetch(`${API_URL}/candidates/${qs ? '?' + qs : ''}`, { headers: headers() }).then(r => r.json());
  },

  getStats: () =>
    fetch(`${API_URL}/candidates/stats`, { headers: headers() }).then(r => r.json()),

  update: (id, data) =>
    fetch(`${API_URL}/candidates/${id}`, {
      method: 'PUT', headers: headers(), body: JSON.stringify(data)
    }).then(r => r.json()),

  contactar: (id, tipo = 'email') =>
    fetch(`${API_URL}/candidates/${id}/contactar`, {
      method: 'POST', headers: headers(), body: JSON.stringify({ tipo })
    }).then(r => r.json()),
};

export const productos = {
  getAll: ({ busqueda = '', page = 1, limit = 50 } = {}) => {
    const qs = new URLSearchParams();
    if (busqueda) qs.set('busqueda', busqueda);
    qs.set('page', page);
    qs.set('limit', limit);
    return fetch(`${API_URL}/productos/?${qs}`, { headers: headers() }).then(r => r.json());
  },
  uploadFeed: (file, modo = 'espejo') => {
    const fd = new FormData();
    fd.append('file', file);
    return fetch(`${API_URL}/productos/upload-feed?modo=${modo}`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${getToken()}` },
      body: fd,
    }).then(r => r.json());
  },
  borrar:     (id) => fetch(`${API_URL}/productos/${id}`,  { method: 'DELETE', headers: headers() }).then(r => r.json()),
  borrarTodos: ()  => fetch(`${API_URL}/productos/all`,    { method: 'DELETE', headers: headers() }).then(r => r.json()),
};
